import React, { FC } from "react";
import { Box, LinearProgress, Typography } from "@mui/material";
import { ValidationProgress } from "../types/interface";

interface ValidationProgressBarProps {
  progress: ValidationProgress;
}

const ValidationProgressBar: FC<ValidationProgressBarProps> = ({ progress }) => {
  const { completed, total } = progress;
  if (total === 0) return null;

  const percent = Math.round((completed / total) * 100);

  return (
    <Box sx={{ px: 1, py: 0.5 }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 0.5 }}>
        <Typography variant="caption" color="white">
          Validierung läuft...
        </Typography>
        <Typography variant="caption" color="white">
          {completed}/{total} Rezepte ({percent}%)
        </Typography>
      </Box>
      <LinearProgress
        variant="determinate"
        value={percent}
        sx={{
          height: 6,
          borderRadius: 3,
          backgroundColor: "rgba(255, 255, 255, 0.62)",
          "& .MuiLinearProgress-bar": {
            borderRadius: 3,
            backgroundColor: "success.main",
          },
        }}
      />
    </Box>
  );
};

export default ValidationProgressBar;
